export const distributionChannel = 'I0';
